// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const HelpFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9 48.5C9 70.28 26.72 88 48.5 88S88 70.28 88 48.5 70.28 9 48.5 9 9 26.72 9 48.5Zm41.781 6.895c-.319 2.147-1.404 3.482-3.573 3.482-2.425 0-3.765-1.758-3.765-4.133v-.619c0-4.035 1.978-6.703 5.966-9.111 3.956-2.441 5.296-4.23 5.296-7.355 0-3.547-2.712-6.02-6.636-6.02-3.54 0-5.902 1.79-6.923 5.076-.702 2.018-1.882 2.831-3.637 2.831C35.308 39.546 34 38.18 34 36c0-1.399.287-2.603.893-3.84C36.871 27.734 41.848 25 48.42 25 57.066 25 63 30.012 63 37.366c0 4.98-2.425 8.396-6.764 11.032-4.179 2.473-5.2 4.035-5.455 6.997Zm1.117 12.984A4.593 4.593 0 0 1 47.272 73c-2.584 0-4.658-2.05-4.658-4.621 0-2.57 2.074-4.589 4.658-4.589 2.584 0 4.626 2.018 4.626 4.589Z"
			fill="#fff"
		/>
	</svg>
);
export default HelpFilled;
